import { routerActions } from './actions';
export var initialState = {
    path: ''
};
export function routerReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case routerActions.UPDATE_LOCATION:
            return action.payload;
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/router-store/src/reducer.js
// module id = 649
// module chunks = 4